import { prescriptionLoadLabel } from "@/lib/patientPrescription";

const text = (value) => String(value ?? "").trim();

function dosage(prescription) {
  const sets = text(prescription.sets);
  const reps = text(prescription.reps);
  const hold = text(prescription.hold_time);
  const frequency = text(prescription.frequency);
  const parts = [];
  if (sets && reps) parts.push(`${sets} x ${reps} reps`);
  else if ((sets || reps) && hold) parts.push(`${sets || reps} x ${hold} holds`);
  else if (sets) parts.push(`${sets} sets`);
  else if (reps) parts.push(`${reps} reps`);
  else if (hold) parts.push(`${hold} hold`);
  if (hold && sets && reps) parts.push(`${hold} hold`);
  // Daily is the expected default and adds little to clinical-note text. Keep more specific prescriptions.
  if (frequency && !/^(daily|every day)$/i.test(frequency)) parts.push(frequency);
  return parts.join(", ");
}

export function formatPrescriptionNote(prescription) {
  const parts = [text(prescription.title || prescription.exercise_name || prescription.name), prescriptionLoadLabel(prescription), dosage(prescription)].filter(Boolean);
  return parts.join(" – ");
}

export function formatProgramNotes(prescriptions) {
  const rows = prescriptions.map(formatPrescriptionNote).filter(Boolean);
  return rows.length ? `HEP prescribed:\n${rows.join("\n")}` : "";
}

export async function copyPrescriptionNotes(value) {
  if (!value || !navigator.clipboard?.writeText) throw new Error("Clipboard access is unavailable");
  await navigator.clipboard.writeText(value);
}
